import { Action, Dispatch } from "redux";
import { getApi } from "../api/ApiProvider";
import initialState from "../initialState";
import { Driver, DriverStateDTO } from "../api/model";
import { NotificationActions } from "./notification/notification-actions";
import { AppDispatch } from "./index";
import {
  default as StoreModel,
  LoadedResource,
  LoadedSingleResource,
} from "./StoreModel";
import { extractError } from "../utils/errorHelper";

export enum DriverActionTypes {
  FETCH_REQUEST = "[DRIVER][LIST] Request",
  FETCH_RESPONSE = "[DRIVER][LIST] Response",
  FETCH_ERROR = "[DRIVER][ERROR] Error",

  SAVE_REQUEST = "[DRIVER][SAVE] Request",
  SAVE_RESPONSE = "[DRIVER][SAVE] Response",
  SAVE_ERROR = "[DRIVER][SAVE] Error",

  DISABLE_REQUEST = "[DRIVER][DISABLE] Request",
  DISABLE_RESPONSE = "[DRIVER][DISABLE] Response",
  DISABLE_ERROR = "[DRIVER][DISABLE] Error",

  ACTIVATE_REQUEST = "[DRIVER][ACTIVATE] Request",
  ACTIVATE_RESPONSE = "[DRIVER][ACTIVATE] Response",
  ACTIVATE_ERROR = "[DRIVER][ACTIVATE] Error",

  LOCATION_ALL_REQUEST = "[DRIVER][REQUEST] Location",
  LOCATION_ALL_RESPONSE = "[DRIVER][RESPONSE] Location",
  LOCATION_ALL_ERROR = "[DRIVER][ERROR] Location",

  LOCATION_SINGLE_REQUEST = "[DRIVER][REQUEST] Location Single",
  LOCATION_SINGLE_RESPONSE = "[DRIVER][RESPONSE] Location Single",
  LOCATION_SINGLE_ERROR = "[DRIVER][ERROR] Location Single",
}

export interface IDriverStore {
  data: LoadedResource<Driver>;
  abm: LoadedSingleResource<Driver>;
  disable: LoadedSingleResource<Driver>;
  activate: LoadedSingleResource<Driver>;
  locations: LoadedResource<DriverStateDTO>;

  locationById: {
    [k: string]: LoadedSingleResource<DriverStateDTO>;
  };
}

export default function reductor(
  state: IDriverStore = initialState.driver,

  action: Action<DriverActionTypes> & { payload: any }
): IDriverStore {
  if (!action) {
    return state;
  }

  switch (action.type) {
    case DriverActionTypes.FETCH_REQUEST:
      return {
        ...state,
        data: StoreModel.fetching(),
      };

    case DriverActionTypes.FETCH_RESPONSE:
      return {
        ...state,
        data: StoreModel.result(action.payload),
      };

    case DriverActionTypes.FETCH_ERROR:
      return {
        ...state,
        data: StoreModel.error(action.payload),
      };

    case DriverActionTypes.SAVE_REQUEST:
      return { ...state, abm: StoreModel.fetchingSingle() };

    case DriverActionTypes.SAVE_RESPONSE:
      return { ...state, abm: StoreModel.resultSingle(action.payload) };

    case DriverActionTypes.SAVE_ERROR:
      return { ...state, abm: StoreModel.errorSingle(action.payload) };

    case DriverActionTypes.DISABLE_REQUEST:
      return { ...state, disable: StoreModel.fetchingSingle() };

    case DriverActionTypes.DISABLE_RESPONSE:
      const id = action.payload.id;
      const index = state.data.data.findIndex((el) => el.id === id);
      const drivers = state.data.data;
      const driversData = [...drivers];
      driversData.splice(index, 1);
      return {
        ...state,
        disable: StoreModel.resultSingle(action.payload),
        data: {
          ...state.data,
          data: driversData.concat(action.payload),
        },
      };
    case DriverActionTypes.DISABLE_ERROR:
      return { ...state, disable: StoreModel.errorSingle(action.payload) };

    case DriverActionTypes.ACTIVATE_REQUEST:
      return { ...state, activate: StoreModel.fetchingSingle() };

    case DriverActionTypes.ACTIVATE_RESPONSE:
      const id2 = action.payload.id;
      const index2 = state.data.data.findIndex((el) => el.id === id2);
      const drivers2 = state.data.data;
      const driversData2 = [...drivers2];
      driversData2.splice(index2, 1);
      return {
        ...state,
        disable: StoreModel.resultSingle(action.payload),
        data: {
          ...state.data,
          data: driversData2.concat(action.payload),
        },
      };
    case DriverActionTypes.ACTIVATE_ERROR:
      return { ...state, activate: StoreModel.errorSingle(action.payload) };

    case DriverActionTypes.LOCATION_ALL_REQUEST:
      return { ...state, locations: StoreModel.fetching() };

    case DriverActionTypes.LOCATION_ALL_RESPONSE:
      return { ...state, locations: StoreModel.result(action.payload) };

    case DriverActionTypes.LOCATION_ALL_ERROR:
      return { ...state, locations: StoreModel.error(action.payload) };

    case DriverActionTypes.LOCATION_SINGLE_REQUEST:
      return {
        ...state,
        locationById: {
          ...state.locationById,
          [action.payload.id]: StoreModel.fetchingSingle(),
        },
      };

    case DriverActionTypes.LOCATION_SINGLE_RESPONSE:
      return {
        ...state,
        locationById: {
          ...state.locationById,
          [action.payload.id]: StoreModel.resultSingle(action.payload.data),
        },
      };

    case DriverActionTypes.LOCATION_SINGLE_ERROR:
      return {
        ...state,
        locationById: {
          ...state.locationById,
          [action.payload.id]: StoreModel.errorSingle(action.payload.data),
        },
      };

    default:
      return state;
  }
}

export class DriverActions {
  filter(search: string) {
    return (dispatch: Dispatch) => {
      dispatch({ type: DriverActionTypes.FETCH_REQUEST });
      getApi()
        .driver()
        .filter(search)
        .then((data) => {
          dispatch({ type: DriverActionTypes.FETCH_RESPONSE, payload: data });
        })
        .catch((err) => {
          dispatch({ type: DriverActionTypes.FETCH_ERROR, payload: err });
        });
    };
  }
  save(data: any) {
    return (dispatch: AppDispatch) => {
      const notif = new NotificationActions();

      dispatch({ type: DriverActionTypes.SAVE_REQUEST });

      getApi()
        .driver()
        .save(data)
        .then((response) => {
          dispatch(notif.addSuccess("Conductor", "Conductor guardado"));
          dispatch({
            type: DriverActionTypes.SAVE_RESPONSE,
            payload: response,
          });
          dispatch(this.fetch());
        })
        .catch((err) => {
          dispatch(notif.addError("Conductor", "Fallo al guardar"));
          dispatch({ type: DriverActionTypes.SAVE_ERROR, payload: err });
        });
    };
  }

  disable(driver: any) {
    const notif = new NotificationActions();
    return (dispatch: AppDispatch) => {
      getApi()
        .driver()
        .disable(driver.id)
        .then((data: any) => {
          dispatch(notif.addSuccess("Conductor", "Conductor deshabilitado"));
          dispatch({ type: DriverActionTypes.DISABLE_RESPONSE, payload: data });
        })
        .catch((err) => {
          dispatch({ type: DriverActionTypes.DISABLE_ERROR, payload: err });
        });
      return dispatch({ type: DriverActionTypes.DISABLE_REQUEST });
    };
  }
  activate(driver: any) {
    const notif = new NotificationActions();
    return (dispatch: AppDispatch) => {
      getApi()
        .driver()
        .activate(driver.id)
        .then((data: any) => {
          dispatch(notif.addSuccess("Conductor", "Conductor habilitado"));
          dispatch({
            type: DriverActionTypes.ACTIVATE_RESPONSE,
            payload: data,
          });
        })
        .catch((err: any) => {
          dispatch({ type: DriverActionTypes.ACTIVATE_ERROR, payload: err });
        });
      return dispatch({ type: DriverActionTypes.ACTIVATE_REQUEST });
    };
  }

  fetchLocationById(driverId: number): any {
    return (dispatch: AppDispatch) => {
      const id = driverId;
      dispatch({
        type: DriverActionTypes.LOCATION_SINGLE_REQUEST,
        payload: { id },
      });
      getApi()
        .driver()
        .location(driverId)
        .then((data) => {
          dispatch({
            type: DriverActionTypes.LOCATION_SINGLE_RESPONSE,
            payload: { id, data },
          });
        })
        .catch((err) => {
          dispatch({
            type: DriverActionTypes.LOCATION_SINGLE_ERROR,
            payload: { id, data: extractError(err) },
          });
        });
    };
  }

  fetchLocations() {
    return (dispatch: AppDispatch) => {
      dispatch({ type: DriverActionTypes.LOCATION_ALL_REQUEST });
      getApi()
        .driver()
        .locations()
        .then((data: DriverStateDTO[]) => {
          dispatch({
            type: DriverActionTypes.LOCATION_ALL_RESPONSE,
            payload: data,
          });
        })
        .catch((err) => {
          dispatch({
            type: DriverActionTypes.LOCATION_ALL_ERROR,
            payload: extractError(err),
          });
        });
    };
  }

  /**
   * Esto sería la lógica de negocio
   */
  fetch() {
    return (dispatch: AppDispatch) => {
      dispatch({ type: DriverActionTypes.FETCH_REQUEST });
      getApi()
        .driver()
        .listActiveByAdmin()
        .then((data) => {
          dispatch({ type: DriverActionTypes.FETCH_RESPONSE, payload: data });
        })
        .catch((err) => {
          dispatch({ type: DriverActionTypes.FETCH_ERROR, payload: err });
        });
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/driver.ts